import React, {Fragment} from 'react';
import {observer} from 'mobx-react';
import {bem} from '../../utils/bem';
import DownloadCell from './DownloadCell';
import Slot from '../../stores/models/Slot';
import Cell from './GridCell';
import ViewSpecsheetCell from './ViewSpecsheetCell';

const block = bem('downgrid');
const allSlot = new Slot('all', {all: true});

const GridRow = ({row, store, isGroupHeader}) => {
	const viewSpecsheetExpanded = row.viewSpecsheetExpanded;
	const parentViewSpecsheetExpanded =  row.parentRow && row.parentRow.viewSpecsheetExpanded;
	const {downloadTypes, toggleSlotSelection, showPDF} = store;
	return (
		<tr className={block('row', {viewSpecsheetExpanded: viewSpecsheetExpanded})}>{
			(row.isSimple || row.isAll) ? (
				<Fragment>
					<Cell modifiers={{first: true, groupLabel: isGroupHeader}}>
						{isGroupHeader ? row.group : ''}
					</Cell>
					<Cell modifiers={{productLabel: true}}>{row.label}</Cell>
					<ViewSpecsheetCell row={row} showPDF={showPDF}
									   onExpand={() => store.toggleSlotSelection(row, row.slots[0], true)}/>
					{downloadTypes.map((type, colIdx) => (
						<DownloadCell key={type} slot={row.slots[colIdx]}
									  blockExpansion={viewSpecsheetExpanded && colIdx === 0}
									  onClick={toggleSlotSelection.bind(store, row)}/>
					))}
					{row.isAll ?
						(<Cell modifiers={{fixed: true}}/>) :
						(<DownloadCell slot={allSlot} onClick={toggleSlotSelection.bind(store, row)}/>)
					}
				</Fragment>
			) : (
				// expanded row!
				<Fragment>
					<Cell modifiers={{first: true}}/>
					<Cell modifiers={{variantLabel: true}} colSpan={1 + row.isExpandedAt}>
						{row.label}
					</Cell>
					{<ViewSpecsheetCell row={row} showPDF={showPDF} dormant={!parentViewSpecsheetExpanded}/>}
					{downloadTypes.map((type, colIdx) => {
						const viewingMultiSpecsheets = parentViewSpecsheetExpanded && colIdx === 0;
						return (<DownloadCell forceDormant={viewingMultiSpecsheets}
											  modifiers={{dormant: viewingMultiSpecsheets || !row.slots[colIdx].downloads}}
											  key={type}
											  slot={row.slots[colIdx]} onClick={toggleSlotSelection.bind(store, row)}/>
						);
					})}
					<Cell modifiers={{fixed: true, dormant: true}}/>
				</Fragment>
			)}
		</tr>
	);
};
export default observer(GridRow);

